/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fine_Top_Pelican_CreateInputs */

const fr_fine_top_pelican_create = /** @type {(inputs: Fine_Top_Pelican_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indique ton adresse e-mail, on t'envoie un lien de réinitialisation.`)
};

/**

* @param {Fine_Top_Pelican_CreateInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fine_top_pelican_create = /** @type {((inputs?: Fine_Top_Pelican_CreateInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fine_Top_Pelican_CreateInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fine_top_pelican_create(inputs)
});